import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import AdminDashboard from '../components/AdminDashboard';
import MechanicDashboard from '../components/MechanicDashboard';
import apiService from '../services/api';
import toast from 'react-hot-toast';

const Dashboard = () => {
  const { user, isAdmin, isMechanic } = useAuth();
  const { t } = useTranslation();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        let response;
        if (isAdmin) {
          response = await apiService.getAdminDashboard();
        } else if (isMechanic) {
          response = await apiService.getMechanicDashboard();
        }

        if (response?.success && response.dashboard) {
          setDashboardData(response.dashboard);
        }
      } catch (error) {
        toast.error(error.message || t('dashboard.messages.failedToLoad', { defaultValue: 'Failed to load dashboard data' }));
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [isAdmin, isMechanic]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
            {t('dashboard.welcomeBack', { name: user?.name })}
          </h2>
          <p className="mt-1 text-sm text-dark-300">
            {isAdmin ? t('dashboard.adminDashboard') : t('dashboard.mechanicDashboard')}
          </p>
        </div>
      </div>

      {isAdmin && <AdminDashboard data={dashboardData} />}
      {isMechanic && <MechanicDashboard data={dashboardData} />}
    </div>
  );
};

export default Dashboard;